// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","lds_ripple":"Loader_lds_ripple__3d1U3","lds-ripple":"Loader_lds-ripple__2N1AD"};